import { lazy, ComponentType } from 'react'
import { lazyWithRetry } from 'routers/utils'

const withLazy = (
  importFn: () => Promise<{ default: ComponentType<unknown> }>
) => lazy(() => lazyWithRetry(importFn))

export const MapEditor = withLazy(() => import('components/map/MapEditor'))

export const Login = withLazy(() => import('routers/pages/Login'))

export const ResetPassword = withLazy(
  () => import('routers/pages/ResetPassword')
)

export const NewPassword = withLazy(() => import('routers/pages/NewPassword'))

export const WorkflowGallery = withLazy(
  () => import('routers/pages/Workflow/Gallery')
)

export const WorkflowEdit = withLazy(
  () => import('routers/pages/Workflow/Edit')
)

export const WorkflowNew = withLazy(() => import('routers/pages/Workflow/New'))

export const WorkflowView = withLazy(
  () => import('routers/pages/Workflow/View')
)

export const Settings = withLazy(() => import('routers/pages/Settings'))

export const UserGallery = withLazy(() => import('routers/pages/UserGallery'))

export const NavigationMapGallery = withLazy(
  () => import('routers/pages/MapGallery')
)

export const NavigationIssueGallery = withLazy(
  () => import('routers/pages/IssueGallery')
)

export const NavigationSiteGallery = withLazy(
  () => import('routers/pages/SiteGallery')
)

export const NavigationSiteEdit = withLazy(
  () => import('components/site/SiteEdit')
)

export const FormGallery = withLazy(() => import('routers/pages/FormGallery'))

export const NavigationFormBuilderEditor = withLazy(
  () => import('components/formBuilder/Editor')
)

export const AssetProfileGallery = withLazy(
  () => import('routers/pages/AssetProfileGallery')
)

export const AssetProfileBuilder = withLazy(
  () => import('components/assets/assetsProfile/Builder')
)

export const NavigationAssetReport = withLazy(
  () => import('components/assets/assetsProfile/viewer/Printable')
)

export const Page404 = withLazy(() => import('routers/pages/Page404'))

export const DynamicScheduling = withLazy(
  () => import('routers/pages/DynamicScheduling')
)

export const LDARSim = withLazy(() => import('routers/pages/LDARSim'))

export const Dashboard = withLazy(() => import('routers/pages/Dashboard'))

export const ReconciliationSiteReport = withLazy(
  () =>
    import('app/MissionControlMethaneSolution/pages/ReconciliationSiteReport')
)

export const OGMP2ByAsset = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/OGMP2/OGMP2ByAsset')
)

export const CAMAssets = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/Assets')
)

export const Reconciliation = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/Reconciliation')
)

export const Audit = withLazy(
  () => import('app/MissionControlMethaneSolution/components/Audit')
)

export const Emissions = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/EmissionEvents')
)

export const Emission = withLazy(
  () =>
    import(
      'app/MissionControlMethaneSolution/pages/EmissionEvents/EmissionEvent'
    )
)

export const EmissionsByAsset = withLazy(
  () =>
    import(
      'app/MissionControlMethaneSolution/pages/EmissionEvents/EmissionsBySite'
    )
)

export const EmissionObservations = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/EmissionObservations')
)

export const CO2e = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/CO2e')
)

export const OGMP2Page = withLazy(
  () => import('app/MissionControlMethaneSolution/pages/OGMP2')
)

export const DevUIPlayground = withLazy(
  () => import('routers/pages/dev/UIPlayground')
)
